import { useState } from "react";

const ClaimModal = ({ profile, onClose, onClaim }) => {
  const [friendlyName, setFriendlyName] = useState("");
  const [phoneNumberSid, setPhoneNumberSid] = useState("");
  const canClaim =
    friendlyName.trim().length > 0 && phoneNumberSid.trim().length > 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-700 p-6 rounded-lg">
        <h2 className="text-xl text-white font-semibold mb-4">Claim Profile</h2>
        <div className="flex flex-col text-gray-300 mb-4">
          <div className="flex whitespace-nowrap items-center text-grey-400 font-medium mb-2">
            <label className="mr-2 w-80">Messaging Service Name:</label>
            <input
              type="text"
              value={friendlyName}
              onChange={(e) => setFriendlyName(e.target.value)}
              required
              className="bg-gray-600 text-white px-2 py-1 rounded w-full"
            />
          </div>
          <div className="flex whitespace-nowrap items-center text-grey-400 font-medium">
            <label className="mr-2 w-80">Phone Number SID:</label>
            <input
              type="text"
              value={phoneNumberSid}
              onChange={(e) => setPhoneNumberSid(e.target.value)}
              required
              placeholder="PNxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
              className="bg-gray-600 text-white px-2 py-1 rounded w-full"
            />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-500"
          >
            Close
          </button>
          <button
            onClick={() =>
              canClaim &&
              onClaim({
                customerProfileSid: profile.sid,
                messagingServiceFriendlyName: friendlyName.trim(),
                phoneNumberSid: phoneNumberSid.trim(),
              })
            }
            disabled={!canClaim}
            className={`ml-2 px-4 py-2 text-white rounded ${
              canClaim
                ? "bg-blue-600 hover:bg-blue-500"
                : "bg-gray-500 cursor-not-allowed"
            }`}
          >
            Claim
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimModal;
